const abbey = "#585A5D";
const activityGrey = "#F4F5F7";
const black = "#000";
const black12 = "rgba(21, 21, 21, .12)";
const black20 = "rgba(21, 21, 21, .20)";
const black26 = "rgba(21, 21, 21, .26)";
const black54 = "rgba(21, 21, 21, .54)";
const black80 = "rgba(21, 21, 21, .8)";
const black300 = "#939393";
const black800 = "#2F2F2F";
const blackRussian0 = "rgba(4, 15, 40, 0)";
const blackRussian = "rgb(4, 15, 40)";
const midnight = "#000718";
const white = "#FFF";
const white24 = "rgba(255, 255, 255, .24)";
const white54 = "rgba(255, 255, 255, .54)";
const white70 = "rgba(255, 255, 255, .7)";
const white80 = "rgba(255, 255, 255, .8)";
const darkBlue = "#000C28";
const gray = "#999";
const darkGray = "#57595C";
const green = "#62CF33";
const ifitBlue = "#0096D6";
const lightGray = "#F4F4F4";
const middleGray = "#B9BABB";
const mountainMeadow = "#28E1A5";
const goldenFizz = "#e0fe32";
const purple = "#830DB4";
const raven = "#828385";
const red = "#EC3324";
const red500 = "#FF3100";
const redApple = "#FD1A0E";
const errorRed = "#D0021B";
const scienceBlue = "#0069D2";
const billingBlue = "#0075D0";
const shark = "#2E3134";
const shark24 = "rgba(46, 49, 52, .24)";
const shark30 = "rgba(46, 49, 52, .3)";
const shark40 = "rgba(46, 49, 52, .4)";
const shark54 = "rgba(46, 49, 52, 0.54)";
const shark80 = "rgba(46, 49, 52, 0.8)";
const venetian = "#BE0219";
const warningRed = "#FF3E33";
const orange400 = "#FF9A26";
const cerulean = "#00C3E5";
const lime = "#C0Df16";

module.exports = {
  abbey,
  activityGrey,
  black,
  black12,
  black20,
  black26,
  black54,
  black80,
  black300,
  black800,
  blackRussian0,
  blackRussian,
  midnight,
  white,
  white24,
  white54,
  white70,
  white80,
  darkBlue,
  gray,
  darkGray,
  green,
  ifitBlue,
  lightGray,
  middleGray,
  mountainMeadow,
  goldenFizz,
  purple,
  raven,
  red,
  red500,
  redApple,
  errorRed,
  scienceBlue,
  billingBlue,
  shark,
  shark24,
  shark30,
  shark40,
  shark54,
  shark80,
  venetian,
  warningRed,
  orange400,
  cerulean,
  lime
};
